import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.exchangeCodeForSession(window.location.search)
      .then(() => supabase.auth.getSession())
      .then(({ data }) => {
        /* Newsletter consent from the login form lives in user_metadata (same key
           as the landing); copy it to the profile, but only on a fresh signup and
           only a yes — a later sign-in must not undo an unsubscribe. */
        const user = data?.session?.user;
        const fresh = Date.now() - Date.parse(user?.created_at || 0) < 24 * 3600 * 1000;
        if (user?.user_metadata?.newsletter_consent === true && fresh) {
          return supabase.from('profiles').update({ newsletter_consent: true }).eq('id', user.id);
        }
        return undefined;
      })
      .catch(() => undefined)
      .then(() => navigate('/tanfolyamok'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{
      minHeight: '100vh', background: '#0f1117',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <p style={{ color: '#00D2C8', fontSize: '14px' }}>Belépés folyamatban...</p>
    </div>
  );
};

export default AuthCallback;
